// roleperms

const mutations = {
	getRolePerms(state, objects) {
  		state.roleperms = objects;
	},

};

export default mutations;